export enum IBulkActionType {
  EDIT = 'edit',
  DELETE = 'delete'
}